import { createTypes } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'

export const healthQuestionTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'HEALTH_QUESTIONS');
export const collectAnswersTypes = createTypes(['SET_ANSWER', 'EXPORT_ANSWERED_QUESTIONS', 'DELETE_ANSWER'], 'COLLECT_ANSWERS');

export const requestHealthQuestions = () => {
    return {
        type: healthQuestionTypes.REQUEST,
    };
};

export const receiveHealthQuestions = (response, insuranceName, query = {}) => {
    return {
        type: healthQuestionTypes.RECEIVE,
        query: query,
        insuranceName: insuranceName,
        data: response,
    };
};

export const receiveHealthQuestionsError = () => {
    return {
        type: healthQuestionTypes.ERROR,
    };
};

export const setQuestionAnswer = (keyValue, customerId, insuranceName, subgroup, groupTitle) => {
    return {
        type: collectAnswersTypes.SET_ANSWER,
        key: keyValue.key,
        value: keyValue.value,
        customerId: customerId,
        insuranceName: insuranceName,
        subgroup: subgroup,
        groupTitle: groupTitle
    };
};

export const removeQuestionAnswer = (key, customerId, insuranceName, infoType) => {
    return {
        type: collectAnswersTypes.DELETE_ANSWER,
        key: key,
        customerId: customerId,
        insuranceName: insuranceName,
        infoType: infoType,
    }
}

export const fetchAllHealthQuestions = (insuranceName, alias=null) => {
    return dispatch => {
        dispatch(requestHealthQuestions());

        if (alias===null) {
            alias = insuranceName
        }
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
        

        return fetch(`/api/v1/questions/` + alias + `/`, {
            headers: headers,
            credentials: 'include',
        })
            .then(parseJSON)
            .then(response => {

                try {
                    dispatch(receiveHealthQuestions(response, insuranceName));
                } catch (e) {
                    dispatch(receiveHealthQuestionsError(response))
                }


            })
            .catch(handleNetworkError);
    }
}

export const exportAnsweredQuestions = (customerId, insuranceName, group, questions) => {
    return {
        type: collectAnswersTypes.EXPORT_ANSWERED_QUESTIONS,
        questions: questions,
        customerId: customerId,
        insuranceName: insuranceName,
        group: group
    };
};